import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

/**
 * Partner/MD pending-approval counts (six tiles). Not server-cached — the
 * numbers must drop right after an item is acted on, so keep it fresh.
 */
export function useCase360PendingApprovals(enabled = true) {
  return useQuery({
    queryKey: dashboardQueryKeys.case360PendingApprovals(),
    queryFn: () => dashboardApi.getCase360PendingApprovals(),
    staleTime: 30 * 1000,
    enabled,
  });
}
